import _toConsumableArray from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function handleCloseModal(modal, canceled) {
  var _a, _b, _c, _d;

  if (canceled && modal.type === "confirm") {
    (_b = (_a = modal.props).onCancel) == null ? void 0 : _b.call(_a);
  }

  (_d = (_c = modal.props).onClose) == null ? void 0 : _d.call(_c);
}

function modalsReducer(state, action) {
  switch (action.type) {
    case "OPEN":
      {
        return {
          current: action.modal,
          modals: [].concat(_toConsumableArray(state.modals), [action.modal])
        };
      }

    case "CLOSE":
      {
        var modal = state.modals.find(function (m) {
          return m.id === action.modalId;
        });

        if (!modal) {
          return state;
        }

        handleCloseModal(modal, action.canceled);
        var remainingModals = state.modals.filter(function (m) {
          return m.id !== action.modalId;
        });
        return {
          current: remainingModals[remainingModals.length - 1] || state.current,
          modals: remainingModals
        };
      }

    case "CLOSE_ALL":
      {
        if (!state.modals.length) {
          return state;
        }

        state.modals.concat().reverse().forEach(function (modal) {
          handleCloseModal(modal, action.canceled);
        });
        return {
          current: state.current,
          modals: []
        };
      }

    default:
      {
        return state;
      }
  }
}

export { modalsReducer };